import { defineStore } from "pinia";
import { ref, computed } from "vue";
import { AuthApi } from "@/api";
import { tokenKey } from "@/enums";
import { useCookies } from "@/composables";

const cookies = useCookies();

export const useAuthStore = defineStore("auth", () => {
  const user = ref(null);
  const loading = ref(false);
  const error = ref(null);

  /**
   * Данные о пользователе
   * @returns {Object|null}
   */
  const getUserData = computed(() => user.value);

  /**
   * Признак загрузки
   * @returns {Boolean}
   */
  const isLoading = computed(() => loading.value);

  /**
   * Получение данных о текущем пользователе
   */
  async function getMe() {
    loading.value = true;
    try {
      const { data } = await AuthApi.getMe();
      user.value = data;
      return data;
    } catch (err) {
      console.error("Ошибка при получении данных о пользователе:", err);
      error.value = err;
      // Пробрасываем, чтобы роут-гарды (auth/permission middleware) могли увести на login.
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function login(payload) {
    loading.value = true;

    try {
      const data = await AuthApi.login(payload);
      cookies.set(tokenKey, data.token);
      user.value = data.user;
    } catch (err) {
      // apiClient reject'ит уже РАЗВЁРНУТОЕ тело ответа (а не axios-error), поэтому
      // путь err.response.data.errors всегда был undefined → терялись реальные ошибки.
      error.value = err?.errors || err || { message: "Ошибка авторизации" };
      throw err;
    } finally {
      loading.value = false;
    }
  }

  function logout() {
    cookies.remove(tokenKey);
    user.value = null;
  }

  return {
    user,
    loading,
    error,
    getUserData,
    isLoading,
    getMe,
    login,
    logout,
  };
});
